import { useEffect, useState } from 'react';
import { Container, Navbar } from 'react-bootstrap';
import classNames from 'classnames';

// hooks
import { useUser } from '../../hooks/auth';

// components
import Menu from './Menu';

// images
import logo from '../../assets/images/logo.svg';

type Navbar5Props = {
    isSticky?: boolean;
    navClass?: string;
    buttonClass?: string;
    fixedWidth?: boolean;
    hideSearch?: boolean;
};

const Navbar5 = ({ isSticky = true, navClass = '', buttonClass }: Navbar5Props) => {
    const { user: loggedInUser } = useUser();
    const [ expanded, setExpanded ] = useState(false);

    useEffect(() => {
        const btnTop = document.getElementById('btn-back-to-top');
        const navbar = document.getElementById('sticky');

        const handleScroll = () => {
            if (btnTop) {
                if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
                    btnTop.classList.add('show');
                } else {
                    btnTop.classList.remove('show');
                }
            }
            if (navbar) {
                if (document.body.scrollTop >= 240 || document.documentElement.scrollTop >= 240) {
                    navbar.classList.add('navbar-sticky');
                } else {
                    navbar.classList.remove('navbar-sticky');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <header>
            <Navbar
                id={isSticky ? 'sticky' : undefined}
                collapseOnSelect
                expand="lg"
                expanded={expanded}
                onToggle={(val) => setExpanded(val)}
                className={classNames('topnav-menu', 'sticky-top', 'shadow', navClass)}
                style={{ zIndex: 1040 }}
            >
                <Container fluid className="px-3 px-sm-4 px-md-9">
                    <Navbar.Brand href="/" className="logo">
                        {/* Logo Desktop */}
                        <img
                            src={logo}
                            height="40"
                            className="d-none d-lg-block align-top"
                            alt="Logo"
                        />
                        {/* Logo Mobile */}
                        <img
                            src={logo}
                            height="30"
                            className="d-lg-none align-top"
                            alt="Logo"
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-menu-content">
                        <Menu
                            showDownload
                            loggedInUser={loggedInUser}
                            navClass="ms-auto"
                            buttonClass={buttonClass ? buttonClass : 'btn-primary'}
                            onItemClick={() => setExpanded(false)}
                        />
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default Navbar5;
